<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 57 89"
         xmlns:xlink="http://www.w3.org/1999/xlink">
     <g id="Слой_x0020_1">
       <metadata id="CorelCorpID_0Corel-Layer"></metadata>
         <path class="inter-fill inter-stroke" :class="{'inter-active':selected}"
               d="M37 12c2,-4 10,-5 12,-1 8,15 -2,45 -13,52 -8,-4 -16,-4 -22,4 0,0 -1,1 -1,1 -4,0 -1,-10 -3,-17 -1,-5 -7,-9 -7,-14 0,-6 2,-11 1,-15 5,-10 6,-21 19,-22 8,0 12,7 14,12zm0 0c0,0 0,0 0,4"></path>
         <path class="fill-black" :class="{'inter-active':selected}" d="M13 67c9,-11 21,-8 30,3 4,4 3,11 13,19 -13,-5 -11,-14 -18,-18 -9,-6 -19,-4 -25,5 -5,9 -5,11 -13,13 7,-8 7,-14 13,-21z"></path>
     </g>
    </svg>
</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'

    export default {
        mixins: [implantMixin]
    }
</script>

<style scoped>

</style>
